import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { IconChevron } from "../ui/icons";
import { buttonClass } from "../ui/primitives";

/** The way back up from a shop page, styled as a button like Cart and Your orders beside it. */
export function ShopBackLink({ to = "/shop", children = "Shop" }: { to?: string; children?: ReactNode }) {
  return (
    <Link to={to} className={buttonClass()}>
      <IconChevron width={16} height={16} className="rotate-90" />
      {children}
    </Link>
  );
}
